// extracted by mini-css-extract-plugin
export var holder = "StandaloneSearchWidget-module--holder--38be2";
export var resultEntry = "StandaloneSearchWidget-module--resultEntry--aba2e";
export var resultEntryLink = "StandaloneSearchWidget-module--resultEntryLink--01ceb";
export var resultEntryList = "StandaloneSearchWidget-module--resultEntryList--c5c3b";
export var resultEntrySynopsis = "StandaloneSearchWidget-module--resultEntrySynopsis--5a39d";
export var resultEntryTitle = "StandaloneSearchWidget-module--resultEntryTitle--62111";
export var results = "StandaloneSearchWidget-module--results--46544";
export var resultsSeparator = "StandaloneSearchWidget-module--resultsSeparator--c3872";
export var searchField = "StandaloneSearchWidget-module--searchField--91506";
export var spinnerActive = "StandaloneSearchWidget-module--spinnerActive--5ec7b";
export var spinnerInactive = "StandaloneSearchWidget-module--spinnerInactive--4d0d5";
export var toggle = "StandaloneSearchWidget-module--toggle--c2202";
export var widget = "StandaloneSearchWidget-module--widget--9fe3a";
export var widgetInput = "StandaloneSearchWidget-module--widgetInput--6efc0";
export var wrapper = "StandaloneSearchWidget-module--wrapper--c932a";
export var wrapperOpen = "StandaloneSearchWidget-module--wrapperOpen--9055a";